<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ajNuLI/tc-custom/9780738214993.jpg?1733082112283" alt="This image is the cover for the book Balance Your Hormones, Balance Your Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Balance Your Hormones, Balance Your Life
      </h1>
      <p class="bookDescription body article font2">
        <b> “A comprehensive overview of Oriental Medicine. . . . [T]he advice is sound. A welcome eastern addition to the women’s health discussion.” –<i>Publishers Weekly</i></b><br/><br/>Internationally renowned Doctor of Oriental Medicine Claudia Welch breaks through the secrets behind hormonal health using the principles of Ayurveda and a holistic sensibility. <i>Balance Your Hormones, Balance Your Life</i> gives women the essential tools to achieve the perfect balance between their yin (sex hormones) and yang (stress hormones), and between the body and the mind.<br/><br/>You'll find the information you need to restore your body's natural harmony, including:Tips to help heal your most pressing concerns, from menstrual pain, infertility, and menopause to breast and heart healthThe best foods to eat for optimal health and wellnessNatural sleep secretsWhat to do when you are just feeling crummyHow stress sabotages hormonal balancePractical, easy-to-adopt stress-management techniques<br/><br/>“A thought-provoking look into the ways our bodies are driven, and, often, run into the ground . . . you will find the beginnings of simple, holistic, and lasting relief.” —<i>San Francisco Book Review</i><br/><br/>“Dr. Welch brings a clear voice to the often confusing and conflicting body of information surrounding hormones and women's health . . . a user-friendly guide that skillfully blends Eastern therapies with Western health concerns.” —<i>Yoga International</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claudia Welch
      </h2>
      
      <p class="authorDescription body article"><B>Dr. Claudia Welch</B> is a Doctor of Oriental Medicine, an Ayurvedic practitioner and educator, and author of several books including <I>Balance Your Hormones, Balance Your Life; Chinese Medicine and Western Science</I>; and <I>The Four Qualities of Effective Physicians</I>. Dr. Welch lectures internationally on Oriental and Ayurvedic medicine, exploring how ideas in Eastern medicine apply to women's health, and today's reality in general. She has served on the teaching faculty of The Ayurvedic Institute, Kripalu School of Ayurveda, Southwest Acupuncture College, and Acupractice Seminars. She lives in Vermont. drclaudiawelch.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Da Capo Lifelong Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0d344005